import React, { useCallback, useEffect, useState } from "react";
import { baseURL, secretKey } from "../../util/config";
import { Table, Chip, Modal, Pager, img, fmt, when } from "./kit";

// Kabileler (yeni sistem): liste, uyeler, uye ekle/cikar, duzenle, guc, yasakla, sil
const req = async (path, body) => {
  const r = await fetch(`${baseURL}clan/admin/${path}`, {
    method: body ? "POST" : "GET",
    headers: { key: secretKey, Authorization: sessionStorage.getItem("token") || "", ...(body ? { "Content-Type": "application/json" } : {}) },
    body: body ? JSON.stringify(body) : undefined,
  });
  try {
    return await r.json();
  } catch (e) {
    return { status: false, message: "Sunucudan geçersiz yanıt." };
  }
};
const ROL = { owner: "Sahip", deputy: "Yardımcı lider", expert: "Uzman", member: "Üye" };
const inp = { width: "100%", padding: "7px 10px", border: "1px solid #E5E7EB", borderRadius: 8, fontSize: 14 };

const ClanAdmin = () => {
  const [q, setQ] = useState("");
  const [page, setPage] = useState(1);
  const [d, setD] = useState({ clans: [], total: 0 });
  const [loading, setLoading] = useState(true);
  const [uye, setUye] = useState(null); // {clan, members}
  const [duz, setDuz] = useState(null);
  const [kod, setKod] = useState("");
  const [yeni, setYeni] = useState(null); // {name, ownerCode, notice}

  const kabileAc = async () => {
    const r = await req("create", yeni);
    if (!r?.status) return window.alert(r?.message || "Açılamadı");
    window.alert(`"${r.name}" açıldı, sahibi ${r.owner}`);
    setYeni(null);
    load();
  };

  const load = useCallback(async () => {
    setLoading(true);
    const r = await req(`list?page=${page}&size=20&q=${encodeURIComponent(q)}`);
    if (r?.status) setD(r);
    setLoading(false);
  }, [page, q]);
  useEffect(() => {
    load();
  }, [load]);

  const sonuc = (r, m) => {
    if (!r?.status) return window.alert(r?.message || "İşlem başarısız"), false;
    if (m) window.alert(m);
    return true;
  };
  const uyeleriAc = async (c) => {
    const r = await req(`members?clanId=${c._id}`);
    if (r?.status) setUye({ clan: c, members: r.members });
  };
  const uyeEkle = async () => {
    if (!kod.trim()) return;
    const r = await req("addMember", { clanId: uye.clan._id, code: kod.trim() });
    if (sonuc(r, `${r.name} kabileye eklendi`)) {
      setKod("");
      uyeleriAc(uye.clan);
      load();
    }
  };
  const cikar = async (m) => {
    if (!window.confirm(`${m.userName} kabileden çıkarılsın mı?`)) return;
    if (sonuc(await req("kick", { clanId: uye.clan._id, userId: m.userId }))) {
      uyeleriAc(uye.clan);
      load();
    }
  };
  const rol = async (m, role) => sonuc(await req("role", { clanId: uye.clan._id, userId: m.userId, role })) && uyeleriAc(uye.clan);
  const kaydet = async () => {
    if (sonuc(await req("update", { clanId: duz._id, name: duz.name, notice: duz.notice, power: duz.power, isOpen: duz.isOpen }), "Kaydedildi")) {
      setDuz(null);
      load();
    }
  };

  return (
    <>
      <div className="d-flex align-items-center" style={{ gap: 8, marginBottom: 12 }}>
        <input style={{ ...inp, maxWidth: 260 }} placeholder="Kabile adı ara" value={q} onChange={(e) => (setQ(e.target.value), setPage(1))} />
        <button className="btn btn-primary" style={{ marginLeft: "auto" }} onClick={() => setYeni({ name: "", ownerCode: "", notice: "" })}>
          + Kabile aç
        </button>
      </div>
      <Modal open={!!yeni} title="Kabile aç" onClose={() => setYeni(null)}>
        {yeni && (
          <>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Kabile adı</label>
            <input style={{ ...inp, marginBottom: 10 }} maxLength={24} value={yeni.name} onChange={(e) => setYeni({ ...yeni, name: e.target.value })} />
            <label style={{ fontSize: 13, fontWeight: 600 }}>Sahibinin ID'si</label>
            <input style={{ ...inp, marginBottom: 10 }} placeholder="ör. 9997760" value={yeni.ownerCode} onChange={(e) => setYeni({ ...yeni, ownerCode: e.target.value })} />
            <label style={{ fontSize: 13, fontWeight: 600 }}>Duyuru (isteğe bağlı)</label>
            <textarea style={{ ...inp, marginBottom: 10 }} rows={2} maxLength={300} value={yeni.notice} onChange={(e) => setYeni({ ...yeni, notice: e.target.value })} />
            <div style={{ fontSize: 12, color: "#6B7280", marginBottom: 10 }}>Coin alınmaz. Logo sahibinin profil fotoğrafı olur, sahibi uygulamadan değiştirebilir.</div>
            <button className="btn btn-primary w-100" onClick={kabileAc}>
              Aç
            </button>
          </>
        )}
      </Modal>
      <Table
        loading={loading}
        head={["Kabile", "Sahip", "Üye", "Seviye", "Güç (bu hafta)", "Durum", ""]}
        empty="Kabile yok."
        rows={d.clans.map((c) => (
          <tr key={c._id}>
            <td>
              <div className="d-flex align-items-center" style={{ gap: 8 }}>
                {c.logo ? <img src={img(c.logo)} alt="" style={{ width: 34, height: 34, borderRadius: 8, objectFit: "cover" }} /> : null}
                <b>{c.name}</b>
              </div>
            </td>
            <td>
              {c.ownerName}
              <div style={{ fontSize: 11, color: "#6B7280" }}>ID {c.ownerCode}</div>
            </td>
            <td>
              {c.memberCount}/{c.maxMembers}
            </td>
            <td>
              {c.levelName} · Lv.{c.level}
            </td>
            <td>
              {fmt(c.power)} <span style={{ fontSize: 11, color: "#6B7280" }}>({fmt(c.weekPower)})</span>
            </td>
            <td>{c.isBanned ? <Chip kind="bad">Yasaklı</Chip> : <Chip>Aktif</Chip>}</td>
            <td style={{ whiteSpace: "nowrap" }}>
              <button className="btn btn-outline-primary btn-sm" onClick={() => uyeleriAc(c)}>
                Üyeler
              </button>{" "}
              <button className="btn btn-outline-secondary btn-sm" onClick={() => setDuz({ ...c })}>
                Düzenle
              </button>{" "}
              <button
                className="btn btn-sm"
                style={{ background: "#B45309", color: "#fff" }}
                onClick={async () => window.confirm(c.isBanned ? "Yasak kaldırılsın mı?" : `"${c.name}" yasaklansın mı?`) && sonuc(await req("ban", { clanId: c._id, ban: !c.isBanned })) && load()}
              >
                {c.isBanned ? "Yasağı kaldır" : "Yasakla"}
              </button>{" "}
              <button
                className="btn btn-danger btn-sm"
                onClick={async () => window.confirm(`"${c.name}" kabilesi ve tüm üyelikleri kalıcı olarak silinsin mi?`) && sonuc(await req("delete", { clanId: c._id })) && load()}
              >
                Sil
              </button>
            </td>
          </tr>
        ))}
      />
      <Pager page={page} size={20} total={d.total} onChange={setPage} />

      <Modal open={!!uye} title={uye ? `${uye.clan.name} · üyeler (${uye.members.filter((m) => m.state === "active").length})` : ""} onClose={() => setUye(null)} wide>
        {uye && (
          <>
            <div className="d-flex" style={{ gap: 6, marginBottom: 12 }}>
              <input style={{ ...inp, maxWidth: 220 }} placeholder="Kullanıcı ID (ör. 90002)" value={kod} onChange={(e) => setKod(e.target.value)} onKeyDown={(e) => e.key === "Enter" && uyeEkle()} />
              <button className="btn btn-primary btn-sm" onClick={uyeEkle}>
                Üye ekle
              </button>
            </div>
            <table className="table table-sm">
              <thead>
                <tr>
                  <th>Üye</th>
                  <th>Rol</th>
                  <th>Katkı</th>
                  <th>Katıldı</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                {uye.members.map((m) => (
                  <tr key={m._id} style={{ opacity: m.state === "active" ? 1 : 0.55 }}>
                    <td>
                      <b>{m.userName}</b> <span style={{ fontSize: 11, color: "#6B7280" }}>ID {m.uniqueID}</span>
                      {m.state !== "active" && <Chip kind="wait">istek</Chip>}
                    </td>
                    <td>
                      {m.role === "owner" ? (
                        "Sahip"
                      ) : (
                        <select value={m.role} onChange={(e) => rol(m, e.target.value)} style={{ fontSize: 12 }}>
                          {["deputy", "expert", "member"].map((r) => (
                            <option key={r} value={r}>
                              {ROL[r]}
                            </option>
                          ))}
                        </select>
                      )}
                    </td>
                    <td>{fmt(m.contribution)}</td>
                    <td style={{ fontSize: 12 }}>{when(m.joinedAt)}</td>
                    <td>
                      {m.role !== "owner" && (
                        <button className="btn btn-outline-danger btn-sm" onClick={() => cikar(m)}>
                          Çıkar
                        </button>
                      )}
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </>
        )}
      </Modal>

      <Modal open={!!duz} title={duz ? `Düzenle · ${duz.name}` : ""} onClose={() => setDuz(null)}>
        {duz && (
          <>
            <label style={{ fontSize: 13, fontWeight: 600 }}>Kabile adı</label>
            <input style={{ ...inp, marginBottom: 10 }} value={duz.name} onChange={(e) => setDuz({ ...duz, name: e.target.value })} />
            <label style={{ fontSize: 13, fontWeight: 600 }}>Duyuru</label>
            <textarea style={{ ...inp, marginBottom: 10 }} rows={3} value={duz.notice || ""} onChange={(e) => setDuz({ ...duz, notice: e.target.value })} />
            <label style={{ fontSize: 13, fontWeight: 600 }}>Güç (seviyeyi belirler)</label>
            <input style={{ ...inp, marginBottom: 10 }} type="number" value={duz.power} onChange={(e) => setDuz({ ...duz, power: e.target.value })} />
            <label className="d-flex align-items-center" style={{ gap: 8, fontSize: 13, marginBottom: 12 }}>
              <input type="checkbox" checked={duz.isOpen} onChange={(e) => setDuz({ ...duz, isOpen: e.target.checked })} /> Herkese açık (istekle katılım)
            </label>
            <button className="btn btn-primary w-100" onClick={kaydet}>
              Kaydet
            </button>
          </>
        )}
      </Modal>
    </>
  );
};

export default ClanAdmin;
